import loadable from 'lib/utils/loadable';

const Loadable = loadable(() => import('./Router'));
export default Loadable;
